// 상세 현황 (새 메뉴) — 기존 상세 현황과 기능이 같고, 사업별·부서별 현황만 진행률 막대 표로 보인다

import DetailDashboardPage from '../DetailDashboard'

export default function DetailStatusDashboardPage() {
  return <DetailDashboardPage groupedStatus />
}
